import React from 'react';
import { BarChart } from '../../../../ui-components/data-viz-ui/charts/bar-chart/BarChart';
import { OverTimeUnsegmentedBarChartUiComponentProps } from './types';

export const OverTimeUnsegmentedBarChartUiComponent = (
  props: OverTimeUnsegmentedBarChartUiComponentProps
) => {
  return (
    <BarChart
      {...props}
      displayConfig={{ ...props.displayConfig, enableSortOrder: false }}
    />
  );
};
